// The /state entry exposes the filter scope without any UI imports.

import { getFilterScope } from '@statsbomb/kitbag-global-football/state';
import { atom } from 'jotai';
import { ConfigFilterAtomValues } from '@/types/userConfigs';

export const comparisonScope = getFilterScope('comparison');

const scopeSnapshotAtom = atom(comparisonScope.get());
scopeSnapshotAtom.onMount = setSnapshot => {
  setSnapshot(comparisonScope.get());
  return comparisonScope.subscribe(setSnapshot);
};

export const comparisonFiltersAtom = atom(
  get => get(scopeSnapshotAtom),
  (_get, set, next: ConfigFilterAtomValues) => {
    comparisonScope.set(next);
    // Write through to the local snapshot so a read in the same store is
    // correct even before (or without) the mount-time subscription.
    set(scopeSnapshotAtom, comparisonScope.get());
  },
);
